import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import WgptBotSourcesAPI from '../../api/wgpt/botSources';
import types from '../mutation-types';
import { throwErrorMessage } from '../utils/api';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isDeleting: false,
    isUpdating: false,
  },
};

export const getters = {
  getSources($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getSource: $state => sourceId => {
    const [source] = $state.records.filter(
      record => record.id === Number(sourceId)
    );
    return source || {};
  },
};

export const actions = {
  get: async ({ commit }, botId) => {
    commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isFetching: true });
    try {
      const wgptBotSourcesAPI = new WgptBotSourcesAPI(botId);
      const response = await wgptBotSourcesAPI.get();
      commit(types.SET_WGPT_BOT_SOURCES, response.data);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, { botId, ...createObj }) => {
    commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isCreating: true });
    try {
      const wgptBotSourcesAPI = new WgptBotSourcesAPI(botId);
      const response = await wgptBotSourcesAPI.create(createObj);
      commit(types.ADD_WGPT_BOT_SOURCE, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isCreating: false });
    }
    return null;
  },
  update: async ({ commit }, { botId, id, ...updateObj }) => {
    commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isUpdating: true });
    try {
      const wgptBotSourcesAPI = new WgptBotSourcesAPI(botId);
      const response = await wgptBotSourcesAPI.update(id, updateObj);
      commit(types.EDIT_WGPT_BOT_SOURCE, response.data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, { botId, id }) => {
    commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isDeleting: true });
    try {
      const wgptBotSourcesAPI = new WgptBotSourcesAPI(botId);
      await wgptBotSourcesAPI.delete(id);
      commit(types.DELETE_WGPT_BOT_SOURCE, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isDeleting: false });
    }
  },
  show: async ({ commit }, { botId, id }) => {
    commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isFetchingItem: true });
    try {
      const wgptBotSourcesAPI = new WgptBotSourcesAPI(botId);
      const { data } = await wgptBotSourcesAPI.show(id);
      commit(types.ADD_WGPT_BOT_SOURCE, data);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_WGPT_BOT_SOURCE_UI_FLAG, { isFetchingItem: false });
    }
  },
};

export const mutations = {
  [types.SET_WGPT_BOT_SOURCE_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.ADD_WGPT_BOT_SOURCE]: MutationHelpers.setSingleRecord,
  [types.SET_WGPT_BOT_SOURCES]: MutationHelpers.set,
  [types.EDIT_WGPT_BOT_SOURCE]: MutationHelpers.update,
  [types.DELETE_WGPT_BOT_SOURCE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
